function imagenFormatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function imagenInitCountdown() {
  var el = document.querySelector('[data-countdown]');
  if (!el) return;
  var target = new Date(el.getAttribute('data-countdown')).getTime();
  if (isNaN(target)) return;

  function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function tick() {
    var diff = Math.max(0, target - Date.now());
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);
    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minutesEl = el.querySelector('[data-minutes]');
    var secondsEl = el.querySelector('[data-seconds]');
    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  }

  tick();
  setInterval(tick, 1000);
}

function imagenUpdateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    el.textContent = count;
    if (count > 0) el.removeAttribute('data-zero');
    else el.setAttribute('data-zero', '');
  });
  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    if (count > 0) btn.removeAttribute('data-empty');
    else btn.setAttribute('data-empty', '');
  });
}

function imagenRenderCart(cart) {
  var body = document.querySelector('[data-cart-body]');
  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  if (!body) return;
  imagenUpdateCartCount(cart.item_count);
  if (!cart.items.length) {
    body.innerHTML = '<div class="cart-drawer-empty">Your cart is empty.</div>';
  } else {
    body.innerHTML = cart.items.map(function (item) {
      return (
        '<div class="cart-line" data-line-key="' + item.key + '">' +
          '<img src="' + item.image + '&width=150" alt="' + (item.product_title || '') + '">' +
          '<div class="cart-line-info">' +
            '<div class="cart-line-title">' + item.product_title + '</div>' +
            (item.variant_title ? '<div class="cart-line-variant">' + item.variant_title + '</div>' : '') +
            '<div class="cart-line-price">' + imagenFormatMoney(item.final_line_price) + '</div>' +
            '<div class="cart-line-qty">' +
              '<button type="button" data-qty-minus aria-label="Decrease quantity">-</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-plus aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="cart-line-remove" data-remove>Remove</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }
  if (subtotalEl) subtotalEl.textContent = imagenFormatMoney(cart.total_price);
}

function imagenFetchCart() {
  return fetch('/cart.js').then(function (r) { return r.json(); });
}

function imagenChangeCartLine(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  }).then(function (r) { return r.json(); }).then(imagenRenderCart);
}

function imagenOpenCart() {
  var overlay = document.querySelector('[data-cart-overlay]');
  var drawer = document.querySelector('[data-cart-drawer]');
  imagenFetchCart().then(function (cart) {
    imagenRenderCart(cart);
    if (overlay) overlay.classList.add('is-open');
    if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
  });
}

function imagenCloseCart() {
  var overlay = document.querySelector('[data-cart-overlay]');
  var drawer = document.querySelector('[data-cart-drawer]');
  if (overlay) overlay.classList.remove('is-open');
  if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
}

document.addEventListener('DOMContentLoaded', function () {
  imagenInitCountdown();

  // Password page: reveal password field behind a small link
  document.querySelectorAll('[data-password-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = document.querySelector('[data-password-form]');
      if (!wrap) return;
      wrap.hidden = false;
      btn.style.display = 'none';
      var input = wrap.querySelector('input[type="password"]');
      if (input) input.focus();
    });
  });

  // scroll reveal
  var revealEls = document.querySelectorAll('.reveal-up');
  function checkReveal() {
    var remaining = false;
    revealEls.forEach(function (el) {
      if (el.classList.contains('is-visible')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.85 && r.bottom > 0) {
        el.classList.add('is-visible');
      } else {
        remaining = true;
      }
    });
    if (!remaining) window.removeEventListener('scroll', checkReveal);
  }
  window.addEventListener('scroll', checkReveal, { passive: true });
  checkReveal();

  // OSA newsletter (Brevo) - swap form for success message on submit
  document.querySelectorAll('.osa-form').forEach(function (form) {
    form.addEventListener('submit', function () {
      setTimeout(function () {
        form.style.display = 'none';
        var success = form.parentElement.querySelector('.osa-success');
        if (success) success.style.display = 'block';
      }, 400);
    });
  });

  // Product gallery + thumbnails
  document.querySelectorAll('.pdp-thumbs').forEach(function (thumbBar) {
    var gallery = document.querySelector(thumbBar.dataset.galleryFor);
    if (!gallery) return;

    var galleryImgs = Array.prototype.slice.call(gallery.querySelectorAll('img'));
    var thumbImgs = Array.prototype.slice.call(thumbBar.querySelectorAll('img'));

    function activateKey(key) {
      var thumb = null;
      galleryImgs.forEach(function (img) {
        img.classList.toggle('is-active', img.dataset.key === key);
      });
      thumbImgs.forEach(function (t) {
        var match = t.dataset.key === key;
        t.classList.toggle('is-active', match);
        if (match) thumb = t;
      });
      if (!thumb) return;

      // Slide the strip so the selected thumb sits toward the centre,
      // clamped at both ends so it never over-scrolls into empty space.
      var target = thumb.offsetLeft - (thumbBar.clientWidth / 2) + (thumb.offsetWidth / 2);
      var maxScroll = thumbBar.scrollWidth - thumbBar.clientWidth;
      if (target < 0) target = 0;
      if (target > maxScroll) target = maxScroll;
      if (thumbBar.scrollTo) {
        thumbBar.scrollTo({ left: target, behavior: 'smooth' });
      } else {
        thumbBar.scrollLeft = target;
      }
    }

    thumbImgs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateKey(thumb.dataset.key);
      });
    });

    // Swipe the main photo to move through the gallery; the thumbnail
    // strip auto-scrolls to follow, same as clicking a thumbnail.
    var touchStartX = null;
    gallery.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var deltaX = e.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(deltaX) < 40) return;
      var currentIndex = galleryImgs.findIndex(function (img) { return img.classList.contains('is-active'); });
      if (currentIndex === -1) currentIndex = 0;
      var nextIndex = deltaX < 0 ? currentIndex + 1 : currentIndex - 1;
      nextIndex = Math.max(0, Math.min(galleryImgs.length - 1, nextIndex));
      var nextImg = galleryImgs[nextIndex];
      if (nextImg) activateKey(nextImg.dataset.key);
    }, { passive: true });
  });

  // Details accordion
  document.querySelectorAll('.pdp-details-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      toggle.classList.toggle('is-open');
      var list = document.getElementById(toggle.dataset.target);
      if (list) list.classList.toggle('is-open');
    });
  });

  // Size / variant picker
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    var idInput = form.querySelector('[name="id"]');
    var addBtn = form.querySelector('.add-to-cart-btn');
    picker.querySelectorAll('.size-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        picker.querySelectorAll('.size-swatch').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        idInput.value = btn.dataset.variantId;
        var available = btn.dataset.available === 'true';
        addBtn.disabled = !available;
        addBtn.textContent = available ? ('ADD TO CART — ' + btn.dataset.size.toUpperCase()) : 'SOLD OUT';
      });
    });
  });

  // Cart drawer
  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', imagenOpenCart);
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', imagenCloseCart);
  });
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  if (cartOverlay) cartOverlay.addEventListener('click', imagenCloseCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') imagenCloseCart();
  });
  var cartBody = document.querySelector('[data-cart-body]');
  if (cartBody) {
    cartBody.addEventListener('click', function (e) {
      var line = e.target.closest('.cart-line');
      if (!line) return;
      var key = line.dataset.lineKey;
      var qtyEl = line.querySelector('.cart-line-qty span');
      var qty = parseInt(qtyEl.textContent, 10);
      if (e.target.matches('[data-qty-plus]')) {
        imagenChangeCartLine(key, qty + 1);
      } else if (e.target.matches('[data-qty-minus]')) {
        imagenChangeCartLine(key, Math.max(0, qty - 1));
      } else if (e.target.matches('[data-remove]')) {
        imagenChangeCartLine(key, 0);
      }
    });
  }

  // Intercept add-to-cart so it opens the drawer instead of reloading the page
  document.querySelectorAll('.pdp-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function () { imagenOpenCart(); })
        .catch(function (err) {
          alert(err && err.description ? err.description : 'Could not add item to cart.');
        });
    });
  });
});
